// export const BASE_URL = "https://contrau.metacoders.dev/wp-json/acf/v3/";
//export const BASE_URL_CONTACT = "https://contrau.metacoders.dev/wp-json/contact-form-7/v1/contact-forms/325/feedback";
export const BASE_URL = "https://contrau.ventures/wp-json/acf/v3/";
export const BASE_URL_CONTACT = "https://contrau.ventures/wp-json/contact-form-7/v1/contact-forms/325/feedback";
